export default __webpack_public_path__ + "static/media/land-7.ef71aeff.png";